<template>
  <div class="columns is-marginless is-paddingless section section-details">
    <div class="column is-10">
      <user-warning-message
        :users="[
          { id: commandeTlpe.commercialId, msg: 'utilisateur.warning.declarantArchive' },
        ]"/>
      <div class="card mgt-20px" id="generalInformations">
        <header class="header-card">
          <p>
            {{ $t('detailCommandeTlpe.infoGenerales.title')}}
          </p>
        </header>
        <info-generales :commande-tlpe="commandeTlpe"></info-generales>
      </div>
      <div class="card mgt-20px" id="collectivite">
        <header class="header-card">
          <p>
            {{ $t('detailCommandeTlpe.collectivite.title')}}
          </p>
        </header>
        <info-collectivite :collectivite="commandeTlpe.intervenants[0]"></info-collectivite>
      </div>
      <div class="card mgt-20px" id="infoMateriel">
        <header class="header-card">
          <p>
            {{ $t('detailCommandeTlpe.infoMateriel.title')}}
          </p>
        </header>
        <info-materiel :commande-tlpe="commandeTlpe"></info-materiel>
      </div>
      <div class="card mgt-20px" id="commentaire">
        <header class="header-card">
          <p>
            {{ $t('detailCommandeTlpe.infoCommentaire.title')}}
          </p>
        </header>
        <info-commentaires :commande-tlpe="commandeTlpe"></info-commentaires>
      </div>
      <div class="card mgt-20px" id="attachments">
        <header class="header-card">
          <p>
            {{ $t('detailCommandeTlpe.piecesJointes.title')}}
          </p>
        </header>
        <div class="card-content">
          <pieces-jointes readOnly
                          deletable
                          autoSave
                          :checkPermissions="checkPermissions(constantes.COMMANDE_TLPE.maj)"
          />
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="is-fixed mgt-20px">
        <dots-menu :steps="steps">
        </dots-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import infoGenerales from '@/components/gabed/commandeTlpe/detail/infoGenerales';
import infoMateriel from '@/components/gabed/commandeTlpe/detail/infoMateriel';
import infoCollectivite from '@/components/gabed/commandeTlpe/infoCollectivite';
import infoCommentaires from '@/components/gabed/commandeTlpe/detail/infoCommentaires';
import { COMMANDE_TLPE } from '@/configuration/gabed/permissionsGabedConf';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import piecesJointes from '@/components/general/piecesJointes';

const Permissions = createNamespacedHelpers('permissions');

export default {
  components: {
    piecesJointes,
    infoGenerales,
    infoMateriel,
    infoCollectivite,
    infoCommentaires,
    userWarningMessage,
  },
  props: {
    commandeTlpe: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      constantes: {
        COMMANDE_TLPE,
      },
    };
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>
